import { callApiToServer } from "../callApi";

export async function deleteSubUser(authtoken, subUserId) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify({
      subUserId: subUserId,
    });

    let endUrl = "v1/auth/sub-user/" + subUserId;

    let responseData = await callApiToServer(body, header, "DELETE", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
